// Mock data for Venkat Swaroop's Leadership Portfolio

export const leadershipQuotes = [
  {
    id: 1,
    quote: "Leadership is not about being in charge. It's about empowering others to reach their fullest potential.",
    author: "Venkat Swaroop"
  },
  {
    id: 2,
    quote: "In talent acquisition, we don't just fill positions—we architect success stories and build lasting legacies.",
    author: "Venkat Swaroop"
  },
  {
    id: 3,
    quote: "Collaboration and continuous growth are the cornerstones of high-performing teams that transform organizations.",
    author: "Venkat Swaroop"
  },
  {
    id: 4,
    quote: "True leadership means fostering a culture where every individual feels valued, heard, and inspired to excel.",
    author: "Venkat Swaroop"
  },
  {
    id: 5,
    quote: "Excellence in recruitment is about understanding human potential and aligning it with organizational vision.",
    author: "Venkat Swaroop"
  }
];

export const personalInfo = {
  name: "Venkat Swaroop",
  fullName: "Venkata Jyothi Swaroop Vemparala",
  title: "Director of Operations | Global Talent Acquisition Leader",
  company: "TekWissen Group",
  location: "Visakhapatnam, India",
  education: { degree: "MBA", institution: "NIBM" },
  email: "venkat@tekwissen.com",
  phone: "+91 7345504449",
  bio: "With nearly 15 years of transformative leadership in global talent acquisition, I steer high-performing teams and partner with Fortune 500 clients across USA, Canada, UK, Europe, Australia, and India. My leadership philosophy centers on empowerment, collaboration, and continuous growth—fostering environments where individuals and organizations thrive together. As a cross-cultural recruitment expert specializing in Staff Augmentation, RPOs, Contingent Workforce Solutions, and Direct Hire Models, I've successfully managed delivery operations with over 1000+ team members throughout my career, serving 100+ customers and generating $15M+ in revenue annually. Today, as Director of Operations, I lead global delivery operations and champion technology and AI innovation in recruitment—including founding RecruiterIQ—uniting operational excellence with product-driven innovation.",
  tagline: "Director of Operations | Global Talent Acquisition Leader | Founder of RecruiterIQ | Recruitment Technology & AI",
  followers: "60K+",
  logo: "https://customer-assets.emergentagent.com/job_leadership-pro/artifacts/lz8889zo_image%20%281%29.png",
  logoMark: "https://static.prod-images.emergentagent.com/jobs/2f025018-f027-4e4f-a15b-3ec8e032a6d3/images/79feb876c05449424676d7d60959c67292960b83df97a244a189b8ae98c701e1.png",
  image: "https://customer-assets.emergentagent.com/job_leadership-pro/artifacts/54n3xnsc_shared%20image%20%285%29.jpeg",
  socialLinks: {
    linkedin: "https://www.linkedin.com/in/venkatjyothiswaroop/",
    wiki: "https://en.wikiflux.org/wiki/index.php/Venkata_Jyothi_Swaroop_Vemparala",
    company: "https://www.tekwissen.com/",
    recruiterIQ: "https://therecruiteriq.com"
  }
};

export const keyMetrics = [
  {
    id: 1,
    value: "500+",
    label: "Talent Management",
    description: "Over 15 years of leadership excellence"
  },
  {
    id: 2,
    value: "100+",
    label: "Fortune 500 Clients",
    description: "Delivering exceptional recruitment solutions"
  },
  {
    id: 3,
    value: "1000+",
    label: "Recruiters Trained",
    description: "Empowering recruitment professionals globally"
  },
  {
    id: 4,
    value: "6",
    label: "Global Markets",
    description: "US, UK, EMEA, India, Australia, Canada"
  }
];

export const industries = [
  { 
    name: "Engineering", 
    icon: "Cog", 
    color: "#1a2332",
    overview: "Deep expertise in recruiting specialized engineering talent across mechanical, electrical, civil, and software engineering domains. Managed high-volume engineering staffing programs for Fortune 500 manufacturing and technology companies.",
    topHiringRoles: [
      "Software Engineers (Full Stack, Backend, Frontend)",
      "Mechanical Engineers",
      "Electrical Engineers",
      "Civil Engineers",
      "DevOps Engineers",
      "Quality Assurance Engineers",
      "Systems Engineers",
      "Project Engineers"
    ],
    topLocations: ["United States", "India", "Canada", "United Kingdom", "Australia", "EMEA"],
    caseStudies: [
      {
        title: "Global Tech Giant - Engineering Talent Transformation",
        description: "Recruited 165 specialized engineers across multiple disciplines for critical product launches, achieving 110% of placement targets with 95% retention rate.",
        impact: "Generated $2.5M in revenue with 6X ROI"
      },
      {
        title: "Manufacturing Leader - Engineering Scale-Up",
        description: "Built dedicated engineering teams for smart manufacturing initiatives, placing 80+ engineers across mechanical, electrical, and automation specializations.",
        impact: "Reduced time-to-fill by 35% through optimized sourcing strategies"
      }
    ]
  },
  { 
    name: "Information Technology", 
    icon: "Code", 
    color: "#2d3748",
    overview: "Comprehensive IT staffing solutions spanning software development, infrastructure, cybersecurity, data analytics, and digital transformation initiatives. Partner with leading tech companies and enterprises undergoing technology modernization.",
    topHiringRoles: [
      "Full Stack Developers (Java, .NET, Python, React, Angular)",
      "Cloud Architects (AWS, Azure, GCP)",
      "Data Scientists & Analytics Engineers",
      "Cybersecurity Specialists",
      "DevOps Engineers",
      "Business Analysts",
      "Scrum Masters & Agile Coaches",
      "IT Project Managers"
    ],
    topLocations: ["United States", "India", "Canada", "United Kingdom", "Australia", "EMEA"],
    caseStudies: [
      {
        title: "Financial Services - Digital Transformation Workforce",
        description: "Staffed 215 IT professionals for large-scale digital transformation including cloud architects, data scientists, and full-stack developers over 12-month RPO engagement.",
        impact: "$8M+ annual spend managed with 30% cost optimization"
      },
      {
        title: "Healthcare Tech - Product Development Team",
        description: "Built complete product engineering team of 50+ developers, QA engineers, and DevOps specialists for healthcare SaaS platform launch.",
        impact: "Achieved 100% placement success within 4 months"
      }
    ]
  },
  { 
    name: "Healthcare & Life Sciences", 
    icon: "Heart", 
    color: "#6b1f3d",
    overview: "Specialized recruitment in healthcare delivery, medical devices, biotechnology, and life sciences research. Expert in sourcing clinical professionals, researchers, and healthcare IT specialists with deep understanding of regulatory compliance requirements.",
    topHiringRoles: [
      "Clinical Research Associates",
      "Medical Science Liaisons",
      "Regulatory Affairs Specialists",
      "Healthcare IT Consultants",
      "Clinical Data Managers",
      "Biostatisticians",
      "Medical Writers",
      "Healthcare Compliance Officers"
    ],
    topLocations: ["United States", "United Kingdom", "India", "Canada", "Australia", "EMEA"],
    caseStudies: [
      {
        title: "Pharmaceutical Leader - Clinical Research Staffing",
        description: "Placed 87 clinical research professionals across multiple therapeutic areas for Phase III trials, achieving 100% regulatory compliance.",
        impact: "Established long-term preferred vendor partnership"
      },
      {
        title: "Medical Device Company - Quality & Compliance Team",
        description: "Recruited specialized regulatory affairs and quality assurance teams for FDA submission processes across US and Europe.",
        impact: "Supported successful product launch in 6 global markets"
      }
    ]
  },
  { 
    name: "Pharmaceutical", 
    icon: "Pill", 
    color: "#8b9a7e",
    overview: "Comprehensive pharmaceutical staffing covering drug development, manufacturing, quality assurance, and regulatory affairs. Strong track record with leading pharma companies in both branded and generic drug sectors.",
    topHiringRoles: [
      "Pharmaceutical Scientists",
      "Quality Control Analysts",
      "Manufacturing Associates",
      "Validation Engineers",
      "Regulatory Affairs Managers",
      "Clinical Operations Managers",
      "Pharmacovigilance Specialists",
      "CMC Specialists"
    ],
    topLocations: ["United States", "India", "United Kingdom", "EMEA", "Canada", "Australia"],
    caseStudies: [
      {
        title: "Generic Pharma - Manufacturing Scale-Up",
        description: "Staffed 120+ manufacturing and quality control professionals for new production facility launch, meeting aggressive timeline requirements.",
        impact: "Facility operational 2 weeks ahead of schedule"
      },
      {
        title: "Biotech Startup - R&D Team Building",
        description: "Built complete research and development team of 35+ pharmaceutical scientists and lab technicians for novel drug discovery program.",
        impact: "Secured Series B funding based on team capabilities"
      }
    ]
  },
  { 
    name: "Banking & Finance", 
    icon: "Building", 
    color: "#d4af37",
    overview: "Strategic recruitment for investment banking, retail banking, fintech, insurance, and wealth management. Expertise in placing front office, middle office, and back-office professionals along with IT and risk management specialists.",
    topHiringRoles: [
      "Financial Analysts",
      "Risk Management Specialists",
      "Compliance Officers",
      "Investment Bankers",
      "Portfolio Managers",
      "Quantitative Analysts",
      "Financial Software Developers",
      "Business Intelligence Analysts"
    ],
    topLocations: ["United States", "United Kingdom", "EMEA", "India", "Canada", "Australia"],
    caseStudies: [
      {
        title: "International Bank - Digital Banking Initiative",
        description: "Recruited 215 professionals for digital transformation including fintech developers, data scientists, and digital product managers.",
        impact: "Renewed 3-year contract with 30% cost savings"
      },
      {
        title: "Investment Firm - Trading Desk Expansion",
        description: "Placed specialized quantitative analysts and algorithmic traders for new trading desk in London and New York offices.",
        impact: "Trading desk profitable within 6 months of launch"
      }
    ]
  },
  { 
    name: "Retail & E-commerce", 
    icon: "ShoppingCart", 
    color: "#2c4a3f",
    overview: "End-to-end recruitment solutions for traditional retail, e-commerce, omnichannel operations, and supply chain. Experience with seasonal staffing, permanent placements, and rapid scaling for peak periods.",
    topHiringRoles: [
      "E-commerce Managers",
      "Supply Chain Analysts",
      "Merchandising Specialists",
      "Digital Marketing Managers",
      "Warehouse Operations Managers",
      "Customer Service Representatives",
      "Retail Store Managers",
      "Logistics Coordinators"
    ],
    topLocations: ["United States", "United Kingdom", "Canada", "Australia", "India", "EMEA"],
    caseStudies: [
      {
        title: "Major Retailer - Seasonal Workforce Program",
        description: "Hired and onboarded 520 seasonal employees across distribution centers within 8 weeks, maintaining 92% attendance rate.",
        impact: "Converted 35% to permanent positions post-season"
      },
      {
        title: "E-commerce Startup - Rapid Growth Staffing",
        description: "Scaled operations team from 15 to 150+ employees in 6 months, supporting 300% revenue growth.",
        impact: "Zero disruption to customer service levels during scaling"
      }
    ]
  },
  { 
    name: "Telecommunications", 
    icon: "Radio", 
    color: "#1a2332",
    overview: "Specialized recruitment for telecom infrastructure, network operations, 5G deployment, and telecommunications software development. Partner with major carriers, equipment manufacturers, and telecom service providers.",
    topHiringRoles: [
      "Network Engineers",
      "Telecommunications Specialists",
      "RF Engineers",
      "5G Implementation Engineers",
      "Network Architects",
      "NOC Engineers",
      "Telecom Project Managers",
      "Field Service Technicians"
    ],
    topLocations: ["United States", "United Kingdom", "Canada", "India", "Australia", "EMEA"],
    caseStudies: [
      {
        title: "Telecom Giant - 5G Rollout Staffing",
        description: "Recruited 200+ network engineers and field technicians for nationwide 5G infrastructure deployment across 15 states.",
        impact: "Deployment completed 3 months ahead of schedule"
      },
      {
        title: "Equipment Manufacturer - R&D Expansion",
        description: "Built specialized R&D teams of 45+ RF engineers and wireless protocol specialists for next-gen equipment development.",
        impact: "Product launch success drove $50M in new contracts"
      }
    ]
  },
  { 
    name: "Professional Services", 
    icon: "Briefcase", 
    color: "#2d3748",
    overview: "Comprehensive staffing for consulting firms, accounting practices, legal services, and advisory organizations. Expertise in placing consultants, analysts, and specialized professional services roles.",
    topHiringRoles: [
      "Management Consultants",
      "Business Analysts",
      "Strategy Consultants",
      "Financial Advisors",
      "Audit & Assurance Associates",
      "Tax Consultants",
      "Legal Associates",
      "HR Consultants"
    ],
    topLocations: ["United States", "United Kingdom", "EMEA", "India", "Canada", "Australia"],
    caseStudies: [
      {
        title: "Big 4 Consulting - Practice Expansion",
        description: "Staffed 150+ consultants across strategy, technology, and operations practices for major consulting firm's market expansion.",
        impact: "Practice grew from $20M to $45M in annual revenue"
      },
      {
        title: "Legal Services - Associate Program",
        description: "Recruited 60+ associates and paralegals for expanding legal practice across corporate law, IP, and litigation departments.",
        impact: "Reduced associate turnover by 40% through quality hiring"
      }
    ]
  },
  { 
    name: "Automotive", 
    icon: "Car", 
    color: "#6b1f3d",
    overview: "Strategic recruitment for automotive manufacturing, electric vehicle development, autonomous systems, and automotive software. Expertise in traditional automotive and emerging mobility technologies.",
    topHiringRoles: [
      "Automotive Engineers",
      "Embedded Software Engineers",
      "Electric Vehicle Specialists",
      "Autonomous Systems Engineers",
      "Manufacturing Engineers",
      "Quality Engineers",
      "Supply Chain Managers",
      "Automotive Test Engineers"
    ],
    topLocations: ["United States", "India", "EMEA", "United Kingdom", "Canada", "Australia"],
    caseStudies: [
      {
        title: "EV Manufacturer - Engineering Team Building",
        description: "Recruited 180+ engineers specializing in battery technology, power electronics, and electric drivetrains for new EV production facility.",
        impact: "Facility achieved production targets 2 quarters early"
      },
      {
        title: "Automotive Supplier - Software Development",
        description: "Built 70+ member software engineering team for autonomous driving systems and ADAS development.",
        impact: "Secured $200M in new OEM contracts"
      }
    ]
  },
  { 
    name: "Insurance & Legal", 
    icon: "Scale", 
    color: "#8b9a7e",
    overview: "Specialized recruitment for insurance carriers, brokers, underwriting, claims management, and legal services. Deep understanding of regulatory requirements and professional licensing needs.",
    topHiringRoles: [
      "Underwriters",
      "Claims Adjusters",
      "Actuaries",
      "Risk Analysts",
      "Insurance Brokers",
      "Corporate Attorneys",
      "Paralegals",
      "Compliance Specialists"
    ],
    topLocations: ["United States", "United Kingdom", "Canada", "EMEA", "Australia", "India"],
    caseStudies: [
      {
        title: "Insurance Carrier - Digital Claims Transformation",
        description: "Recruited 90+ professionals including claims adjusters, IT specialists, and data analysts for digital claims processing initiative.",
        impact: "Claims processing time reduced by 60%"
      },
      {
        title: "Law Firm - National Expansion",
        description: "Staffed 8 new office locations with 120+ attorneys, paralegals, and legal support professionals across multiple practice areas.",
        impact: "Expansion generated $30M in first-year revenue"
      }
    ]
  }
];

export const experience = [
  {
    id: 4,
    title: "Director of Operations",
    company: "TekWissen Group",
    duration: "June 2026 - Present",
    location: "Global Operations",
    responsibilities: [
      "Lead global delivery operations across multiple geographies, overseeing 400+ team members and end-to-end talent delivery",
      "Define organizational strategy for talent acquisition, workforce planning, and operational excellence",
      "Own multi-million dollar budgets and resource allocation across global delivery operations",
      "Partner with C-suite executives of Fortune 500 clients to align talent strategies with business outcomes",
      "Drive process innovation, automation, and continuous improvement across the operations function"
    ]
  },
  {
    id: 1,
    title: "Associate Director",
    company: "TekWissen Group",
    duration: "January 2023 - May 2026",
    location: "Global Operations",
    responsibilities: [
      "Oversaw all aspects of personnel management for 400+ team members including hiring, training, and performance evaluation",
      "Developed and implemented strategic systems for staff assessment and development to improve productivity, efficiency, and team morale",
      "Managed multi-million dollar budgets and resources across global delivery operations",
      "Ensured compliance with international recruitment regulations and standards",
      "Partnered with C-suite executives of Fortune 500 clients to align talent strategies with business outcomes"
    ]
  },
  {
    id: 2,
    title: "Senior Program Manager",
    company: "TekWissen Group",
    duration: "September 2021 - January 2023",
    location: "US | Canada | EMEA | UK | India",
    responsibilities: [
      "Led full-cycle recruitment across multiple geographies delivering quality talent within time and budget constraints",
      "Streamlined recruiting and resourcing processes improving team efficiency by 35%",
      "Managed strategic resource planning, workforce analysis, and vendor management programs",
      "Coordinated with HR leadership on organization-wide policies and recruitment operations"
    ]
  },
  {
    id: 3,
    title: "Deputy Manager - Operations & Staffing",
    company: "TekWissen Group",
    duration: "July 2019 - August 2021",
    location: "United States | Canada | UK | EMEA | India | Australia",
    responsibilities: [
      "Managed delivery operations across six global markets with diverse team of 200+ members",
      "Captured and forecasted current and future manpower demand for strategic workforce planning",
      "Conceptualized and implemented process improvements resulting in 25% productivity increase",
      "Assessed future requirements for resources and skills based on historical trends and demand plans"
    ]
  }
];

export const caseStudies = [
  {
    id: 1,
    title: "Fortune 500 Tech Giant: Global Engineering Talent Transformation",
    domain: "Engineering & Technology",
    client: "Leading Technology Corporation",
    challenge: "Required 150+ specialized engineers across US, UK, and India within 6 months for critical product launch",
    solution: "Implemented multi-geography recruitment strategy with dedicated teams, leveraged AI-driven sourcing, and established strategic partnerships with engineering institutions",
    results: [
      "Successfully placed 165 engineers (110% of target) within 5.5 months",
      "Achieved 95% candidate retention rate after 12 months",
      "Reduced time-to-fill by 40% through process optimization",
      "Generated $2.5M in project revenue with 6X ROI"
    ],
    metrics: { team: "50+", duration: "6 months", placements: "165", retention: "95%" }
  },
  {
    id: 2,
    title: "Pharmaceutical Leader: Clinical Research Staffing Excellence",
    domain: "Healthcare & Life Sciences",
    client: "Global Pharmaceutical Company",
    challenge: "Urgent need for 80+ clinical research professionals across multiple therapeutic areas for Phase III trials",
    solution: "Deployed specialized healthcare recruitment team, created talent pipeline through medical associations, and implemented rigorous compliance screening processes",
    results: [
      "Placed 87 qualified clinical professionals within 4 months",
      "100% compliance with regulatory requirements",
      "Achieved 25% representation in top 3 vendor rankings",
      "Established long-term preferred vendor partnership"
    ],
    metrics: { team: "35+", duration: "4 months", placements: "87", compliance: "100%" }
  },
  {
    id: 3,
    title: "Financial Services: Digital Transformation Workforce",
    domain: "Banking & Finance",
    client: "International Banking Institution",
    challenge: "Large-scale digital transformation requiring 200+ IT professionals including data scientists, cloud architects, and cybersecurity experts",
    solution: "Established dedicated RPO model, created talent mapping for niche skills, and implemented diversity hiring initiatives achieving 40% diverse candidate placement",
    results: [
      "Successfully staffed 215 professionals across 12-month engagement",
      "Exceeded diversity targets by 15%",
      "Managed $8M+ annual spend with 30% cost optimization",
      "Renewed contract for additional 3 years"
    ],
    metrics: { team: "75+", duration: "12 months", placements: "215", savings: "30%" }
  },
  {
    id: 4,
    title: "Retail Giant: Seasonal Workforce Scaling",
    domain: "Retail & E-commerce",
    client: "Major Retail Corporation",
    challenge: "Rapid scaling required for holiday season: 500+ temporary workforce across distribution centers and customer service",
    solution: "Implemented contingent workforce management program, utilized job fairs and college recruiting, and created fast-track onboarding process",
    results: [
      "Hired and onboarded 520 employees within 8 weeks",
      "Maintained 92% attendance rate throughout season",
      "Converted 35% to permanent positions post-season",
      "Generated $3.2M in seasonal staffing revenue"
    ],
    metrics: { team: "25+", duration: "8 weeks", placements: "520", conversion: "35%" }
  }
];

export const achievements = [
  {
    id: 1,
    title: "Top Staffing Leaders to Watch - 2025",
    organization: "Candidate.ly",
    year: "2025",
    category: "Industry Recognition"
  },
  {
    id: 2,
    title: "Top Staffing Leaders to Watch - 2024",
    organization: "Candidate.ly",
    year: "2024",
    category: "Industry Recognition"
  },
  {
    id: 3,
    title: "Top 10 Growing Influential Leaders",
    organization: "FoxStory",
    year: "2023",
    category: "Leadership Award"
  },
  {
    id: 4,
    title: "40 Under 40 - Dynamic Leaders",
    organization: "HRAI",
    year: "2023",
    category: "Leadership Award"
  },
  {
    id: 5,
    title: "40 Under 40 Prominent & Inspiring Indian Personality",
    organization: "Economic Times - Glaze Iconic Awards",
    year: "2023",
    category: "Leadership Award"
  },
  {
    id: 6,
    title: "Top 100 Influential Leaders",
    organization: "Leadify India",
    year: "2023",
    category: "Leadership Award"
  },
  {
    id: 7,
    title: "Top 100 Under 50 Executive and Emerging Leaders",
    organization: "DiversityMBA",
    year: "2023",
    category: "Leadership Award"
  },
  {
    id: 8,
    title: "Top 100 Great People Managers",
    organization: "Forbes India",
    year: "2022",
    category: "Management Excellence"
  },
  {
    id: 9,
    title: "World's Best Recruiters",
    organization: "RChilli",
    year: "2021",
    category: "Industry Recognition"
  }
];

export const certifications = [
  { id: 1, name: "Certified Talent Acquisition Professional", issuer: "SHRM", year: "2023" },
  { id: 2, name: "Certified Internet Recruiter", issuer: "AIRS", year: "2022" },
  { id: 3, name: "Certified Recruitment Analyst", issuer: "MEHR", year: "2021" },
  { id: 4, name: "Certified Contingent Workforce Program (CCWP) - Trained", issuer: "SIA", year: "In Progress", note: "Certification under process" },
  { id: 5, name: "Independent Directors - Trained", issuer: "Professional Development", year: "In Progress", note: "Certification under process" },
  { id: 6, name: "ISO 9001:2015 Lead Auditor (QMS)", issuer: "ISO", year: "2019" },
  { id: 7, name: "Master of Business Administration - HR/Leadership", issuer: "NIBM Global", year: "2019" },
  { id: 8, name: "CompTIA A+ Certification", issuer: "CompTIA", year: "2012" },
  { id: 9, name: "CompTIA Network+ Certification", issuer: "CompTIA", year: "2012" }
];

export const memberships = [
  {
    id: 1,
    organization: "HR Association of India",
    role: "Member",
    period: "2025 - Present",
    status: "Active",
    website: "https://hrassociationindia.com/",
    linkedin: "https://www.linkedin.com/company/hr-association-of-india/about/"
  },
  {
    id: 2,
    organization: "Global Mentorship Initiative",
    role: "Mentor",
    period: "2025 - Present",
    status: "Active",
    website: "https://globalmentorship.org/",
    linkedin: "https://www.linkedin.com/company/globalmentorship/"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Senior VP, Fortune 500 Technology Company",
    role: "Client Executive",
    company: "Global Tech Corporation",
    text: "Venkat's ability to understand our complex engineering requirements and deliver exceptional talent consistently is remarkable. His team's responsiveness and quality of candidates have made them our preferred staffing partner. The 6X ROI he generates is unmatched in the industry.",
    rating: 5
  },
  {
    id: 2,
    name: "HR Director",
    role: "Human Resources Leadership",
    company: "International Pharmaceutical Company",
    text: "Working with Venkat has been transformative for our clinical research staffing needs. His deep understanding of compliance requirements and ability to source specialized healthcare talent sets him apart. He doesn't just fill positions—he builds lasting partnerships.",
    rating: 5
  },
  {
    id: 3,
    name: "Team Member",
    role: "Senior Recruitment Manager",
    company: "TekWissen Group",
    text: "Venkat is always there - you can count on him. He listens to what others have to say and always resolves issues in a polite manner. His leadership style empowers us to excel and continuously grow. He has a knack for seeing ways to do more with less.",
    rating: 5
  },
  {
    id: 4,
    name: "Chief Talent Officer",
    role: "Executive Leadership",
    company: "Leading Financial Services Firm",
    text: "Venkat's strategic approach to workforce planning and his ability to scale teams rapidly while maintaining quality is impressive. His expertise in vendor management and MSP programs saved us 30% in costs while improving our talent acquisition outcomes significantly.",
    rating: 5
  },
  {
    id: 5,
    name: "Direct Report",
    role: "Operations Manager",
    company: "TekWissen Group",
    text: "He's very tenacious, sticks with it until it gets done. Venkat takes initiatives and gets recognized in the organization quickly. Under his leadership, I've grown tremendously both professionally and personally. He truly embodies the principle of empowering others.",
    rating: 5
  },
  {
    id: 6,
    name: "VP Operations",
    role: "Client Partner",
    company: "Major Retail Corporation",
    text: "The seasonal workforce program Venkat designed for us was flawless. His team hired and onboarded 520 employees in just 8 weeks with a 92% attendance rate. This level of execution and attention to detail is why we continue to partner with him year after year.",
    rating: 5
  }
];

export const services = [
  {
    id: 1,
    title: "Contingent Staffing",
    description: "Expert temporary and contract staffing solutions for Fortune 500 companies across multiple industries. Strategic workforce management with focus on quality, speed, and cost optimization.",
    features: [
      "Flexible workforce solutions",
      "Rapid candidate deployment",
      "Quality assurance processes",
      "Vendor management systems"
    ],
    icon: "Users"
  },
  {
    id: 2,
    title: "RPO (Recruitment Process Outsourcing)",
    description: "End-to-end recruitment process management delivering scalable talent acquisition solutions. Proven track record of managing large-scale hiring initiatives across global markets.",
    features: [
      "Full-cycle recruitment management",
      "Scalable hiring solutions",
      "Advanced sourcing strategies",
      "Employer branding support"
    ],
    icon: "Target"
  },
  {
    id: 3,
    title: "Full-Time Recruitment",
    description: "Permanent placement services connecting top talent with leading organizations. Specialized in executive search and direct hire for critical business roles.",
    features: [
      "Executive search services",
      "Direct hire placements",
      "Talent mapping and pipelining",
      "Long-term retention strategies"
    ],
    icon: "Briefcase"
  },
  {
    id: 4,
    title: "MSP Management",
    description: "Managed Service Provider programs optimizing contingent workforce operations. Strategic oversight of multiple vendors ensuring quality, compliance, and cost efficiency.",
    features: [
      "Multi-vendor coordination",
      "Program governance",
      "Performance metrics tracking",
      "Cost optimization strategies"
    ],
    icon: "Network"
  },
  {
    id: 5,
    title: "System Integrators",
    description: "Technology staffing solutions for complex IT projects and transformations. Deep expertise in placing specialized technical talent for enterprise-level implementations.",
    features: [
      "Technical talent acquisition",
      "Project-based staffing",
      "Niche skill sourcing",
      "Rapid deployment capabilities"
    ],
    icon: "Cpu"
  },
  {
    id: 6,
    title: "HR Management",
    description: "Comprehensive human resources solutions including policy development, workforce planning, and organizational effectiveness initiatives.",
    features: [
      "HR strategy consulting",
      "Workforce planning",
      "Policy development",
      "Organizational design"
    ],
    icon: "UserCog"
  },
  {
    id: 7,
    title: "360 Recruitment",
    description: "Full-spectrum recruitment services from initial consultation to post-placement support. Holistic approach ensuring perfect candidate-client alignment.",
    features: [
      "End-to-end recruitment cycle",
      "Client relationship management",
      "Candidate experience optimization",
      "Post-placement follow-up"
    ],
    icon: "RefreshCw"
  },
  {
    id: 8,
    title: "Immigration & Compliance",
    description: "Expert guidance on work authorization, visa processing, and regulatory compliance for global workforce management.",
    features: [
      "Visa sponsorship support",
      "Work authorization management",
      "Regulatory compliance",
      "Documentation assistance"
    ],
    icon: "FileCheck"
  },
  {
    id: 9,
    title: "Quality Auditing",
    description: "Comprehensive quality assurance processes ensuring recruitment excellence and operational efficiency across all delivery functions.",
    features: [
      "Process audits",
      "Quality metrics tracking",
      "Performance improvement plans",
      "Compliance verification"
    ],
    icon: "CheckCircle"
  },
  {
    id: 10,
    title: "Learning & Development",
    description: "Training and development programs for recruitment teams and HR professionals. Building capability and enhancing skills for sustained excellence.",
    features: [
      "Recruiter training programs",
      "Leadership development",
      "Skills enhancement workshops",
      "Industry best practices"
    ],
    icon: "GraduationCap"
  },
  {
    id: 11,
    title: "Building Solutions through AI",
    description: "Innovative AI-powered tools and platforms revolutionizing recruitment processes. Custom software solutions designed to solve real business challenges cost-effectively.",
    features: [
      "AI-driven candidate matching",
      "Recruitment automation",
      "Predictive analytics",
      "Custom HR-tech solutions"
    ],
    icon: "Sparkles"
  },
  {
    id: 12,
    title: "Recruiter IQ Platform",
    description: "Founder of TheRecruiterIQ.com - An innovative platform empowering recruiters with advanced tools, training, and resources to excel in modern talent acquisition.",
    features: [
      "Advanced training programs",
      "Market intelligence",
      "Community networking",
      "Cutting-edge technology"
    ],
    icon: "Lightbulb",
    link: "https://therecruiteriq.com"
  }
];
